// material-ui

import removeresourceicon from '../../../assets/images/remove-resource.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const RemoveResourceIcon = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={removeresourceicon} alt="Remove Resource" width="22"  className={props.className || 'abc'} />
    );
};

export default RemoveResourceIcon;
